// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2J28w","subheader":"ReorderModal_subheader__Sxg4I","listWrap":"ReorderModal_listWrap__1vFX6"};